/*
 * @Author: jiji
 * @Date: 2023-08-17 16:53:28
 * @LastEditors: jiji
 * @LastEditTime: 2023-08-18 12:05:40
 * @FilePath: \KrenzFront1215\src\components\floatingph.js
 * @Description:
 *
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved.
 */
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
export const Floatingph = (props) => {
  let { showmp, showFloating, text, setText } = props;
  return (
    <div>
      <div
        className={!showmp ? "floating-mp" : "hide"}
        onTouchStart={(e) => showFloating(e)}
      >
        <div></div>
      </div>
      <div
        className={showmp ? "floating-mp-window" : "hide"}
        onTouchStart={(e) => showFloating(e)}
      >
        <div className="top">
          <div className="head-portrait"></div>
        </div>
        <div className="bottom">
          <div className="contract"></div>
          {/* <div className="KKname"></div> */}
          <div className="QQ"></div>
        </div>
        <div className="button">
          <CopyToClipboard text="800180805" onCopy={() => setText("已复制")}>
            <div className={text === "已复制" ? "hide" : "button1"}>
              <div className="copy"></div>
            </div>
          </CopyToClipboard>
          <div className={text === "一键复制QQ号" ? "hide" : "button1"}>
            <div className="alcopy"></div>
          </div>
          <div className="button2">
            <Link to="/commonproblem/seid/0">
              <div></div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
